import React, { useContext, Fragment } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { AuthContext } from '../context/auth';

function PrivateRoute({ component: Component, ...rest }) {
  const { user } = useContext(AuthContext);

  return (
    <Fragment>
      <Helmet>
        <meta name="robots" content="noimageindex, noarchive" />
      </Helmet>
      <Route
        {...rest}
        render={(props) =>
          user ? <Component {...props} /> : <Redirect to="/" />
        }
      />
    </Fragment>
  );
}

export default PrivateRoute;
